__turbopack_context__.v({
  "hideOnMobile": "styles-module-scss-module__Im6BjW__hideOnMobile",
});
